<template>
  <div>
    <textarea
      class="form-control form-control-sm"
      id="exampleTextarea1"
      rows="4"
      :name="name"
      v-model="post"
      @input="send"
      :required="required"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content
    };
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post
      });
    }
  }
};
</script>